import qs from 'qs';

import {fetchJSONMemoized} from './fetchJSON';

export interface FetchPaginatedJSONOptions {
    itemsPerPage?: number;
    maxItems?: number;
    firstPage?: number;
}

export default async function* fetchPaginatedJSON<T>(
    url: string,
    {itemsPerPage = 1000, maxItems = 1000000, firstPage = 1}: FetchPaginatedJSONOptions = {}
): AsyncIterable<T> {
    const lastPage = Math.ceil(maxItems / itemsPerPage) + firstPage - 1;

    for (let page = firstPage; page <= lastPage; page++) {
        const data = await fetchJSONMemoized(
            appendQueryParams(url, {
                page,
                count: itemsPerPage,
            })
        );

        for (const datum of data) {
            yield datum;
        }

        if (data.length < itemsPerPage) return;
    }
}

function appendQueryParams(input: string, query: Record<string, any>) {
    const [head, tail] = input.split('?');
    return (
        head +
        '?' +
        qs.stringify({
            ...query,
            ...qs.parse(tail),
        })
    );
}
